import Tooltip from 'Component/tooltip';
import MonitoringOperator from 'Component/monitoring-operator';
import CustomModal from 'UiKit/modal';
import Loader from 'Component/loader';
import Toast from 'UiKit/toast';
import HelpHostModal from 'Component/help-host-modal';

const DashboardWidget = () => {
  return (
    <>
      <Toast />
      <CustomModal />
      <Loader />
      <Tooltip />
      <MonitoringOperator />
      <HelpHostModal />
    </>
  );
};

export default DashboardWidget;
